/*
 * LZ upsell - "Complete your offer" slider (Oct 2026).
 * snippets/lz-upsell.liquid renders a hidden placeholder [data-lz-upsell] (below the cart items in
 * the drawer and on /cart) with data-src = the collection URL to pull from (offer collection, or
 * shop-all with a price filter for the 10% gap-filler), the product ids already in the cart, and
 * data-skip-offers when offer-collection items must be left out.
 * This file fills it with up to 12 product cards from sections/lz-upsell-data.liquid
 * (best-selling, in stock), one fetch per collection per page view (cached).
 * Products with real colour/size variants get a "Choose <option>" dropdown; Add stays inert
 * (and highlights the dropdown) until a choice is made, so nothing is added in a wrong variant.
 * "Add" posts to /cart/add.js, redraws the drawer (or the /cart sections) and then publishes
 * Dawn's cartUpdate with source 'cart-items' so free-gift.js runs its auto-offer celebration
 * while Dawn's own CartItems listeners skip a second redraw.
 */
(function () {
  if (window.__lzUpsellInit) return;
  window.__lzUpsellInit = true;

  var MAX_CARDS = 12;
  var cache = {};
  var busy = false;

  function injectStyles() {
    if (document.getElementById('lz-upsell-styles')) return;
    var css =
      '.lz-up{margin:12px 0 4px;padding:10px 0 6px;border-top:1px dashed #f3a6bb;text-align:left;width:100%;box-sizing:border-box}' +
      '.lz-up[hidden]{display:none!important}' +
      '.lz-up--note{padding:8px 0 4px}' +
      '.lz-up__head{display:flex;align-items:baseline;justify-content:space-between;gap:8px}' +
      '.lz-up__title-line{margin:0;font-size:1.4rem;line-height:1.3;font-weight:600;color:#c2185b}' +
      '.lz-up__title-line strong{font-weight:800}' +
      '.lz-up__all{font-size:1.2rem;color:#c2185b;text-decoration:underline;white-space:nowrap}' +
      '.lz-up__sub{margin:2px 0 8px;font-size:1.15rem;line-height:1.3;color:#777}' +
      '.lz-up__row{display:flex;gap:8px;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;' +
      '-webkit-overflow-scrolling:touch;overscroll-behavior-x:contain;padding-bottom:4px;scrollbar-width:thin}' +
      '.lz-up__card{flex:0 0 104px;max-width:104px;scroll-snap-align:start;display:flex;flex-direction:column;' +
      'border:1px solid #eee;border-radius:8px;padding:5px;background:#fff;box-sizing:border-box}' +
      '.lz-up__img{display:block;border-radius:6px;overflow:hidden;background:#f6f6f6;aspect-ratio:1/1}' +
      '.lz-up__img img{display:block;width:100%;height:100%;object-fit:cover}' +
      '.lz-up__name{display:block;margin-top:4px;font-size:1.1rem;line-height:1.25;color:#222;text-decoration:none;' +
      'white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '.lz-up__price{margin:2px 0 5px;font-size:1.15rem;line-height:1.25;font-weight:600;color:#222;' +
      'white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '.lz-up__price s{margin-right:3px;font-size:1rem;font-weight:400;color:#999}' +
      '.lz-up__add{margin-top:auto;display:block;width:100%;min-height:30px;padding:4px 0;border:0;border-radius:5px;' +
      'background:#c2185b;color:#fff;font-size:1.2rem;font-weight:600;letter-spacing:.02em;text-align:center;' +
      'text-decoration:none;line-height:22px;cursor:pointer;font-family:inherit}' +
      '.lz-up__add[disabled]{opacity:.6;cursor:default}' +
      '.lz-up__sel{display:block;width:100%;height:30px;margin:0 0 5px;padding:0 2px;border:1px solid #ddd;border-radius:5px;' +
      'background:#fff;color:#222;font-size:16px;font-family:inherit;box-sizing:border-box}' +
      '.lz-up__sel--err{border-color:#d81b3c;box-shadow:0 0 0 2px rgba(216,27,60,.25)}' +
      /* Hide the floating WhatsApp/call buttons (#wfb-wrapper, app) and the round video bubble
         (#lz-vw) while the cart drawer is open and on the /cart page - they covered slider cards
         and the cart total on mobile. */
      '.lz-up__toast{position:fixed;left:50%;bottom:90px;z-index:2147483647;max-width:300px;width:calc(100% - 48px);' +
      'padding:12px 16px;border-radius:10px;background:#c2185b;color:#fff;font-size:1.4rem;line-height:1.35;font-weight:600;' +
      'text-align:center;box-shadow:0 6px 20px rgba(0,0,0,.25);pointer-events:none;opacity:0;' +
      'transform:translate(-50%,12px);transition:opacity .2s,transform .2s}' +
      '.lz-up__toast.is-in{opacity:1;transform:translate(-50%,0)}' +
      'html.lz-cart-open #wfb-wrapper,html.lz-cart-open #lz-vw,' +
      'body:has(cart-drawer.active) #wfb-wrapper,body:has(cart-drawer.active) #lz-vw,' +
      'body:has(cart-items) #wfb-wrapper,body:has(cart-items) #lz-vw{display:none!important}';
    var style = document.createElement('style');
    style.id = 'lz-upsell-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function load(src) {
    if (!cache[src]) {
      var url = src + (src.indexOf('?') === -1 ? '?' : '&') + 'section_id=lz-upsell-data';
      cache[src] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var node = doc.querySelector('[data-lz-upsell-json]');
          if (!node) throw new Error('no data');
          var list = JSON.parse(node.textContent);
          return Array.isArray(list) ? list : [];
        })
        .catch(function (e) {
          delete cache[src];
          throw e;
        });
    }
    return cache[src];
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function buildCard(p) {
    var card = el('div', 'lz-up__card');

    var imgLink = el('a', 'lz-up__img');
    imgLink.href = p.url;
    if (p.img) {
      var img = document.createElement('img');
      img.src = p.img;
      img.alt = p.title || '';
      img.loading = 'lazy';
      img.width = 300;
      img.height = 300;
      imgLink.appendChild(img);
    }
    card.appendChild(imgLink);

    var name = el('a', 'lz-up__name', p.title || '');
    name.href = p.url;
    card.appendChild(name);

    var price = el('p', 'lz-up__price');
    if (p.compare) price.appendChild(el('s', null, p.compare));
    price.appendChild(document.createTextNode(p.price || ''));
    card.appendChild(price);

    var vars = Array.isArray(p.vars) ? p.vars : [];
    var add = el('button', 'lz-up__add', 'Add');
    add.type = 'button';
    add.setAttribute('aria-label', 'Add ' + (p.title || 'item') + ' to cart');

    if (vars.length > 1) {
      /* Real colour/size choices: shopper must pick one before Add works (no silent default). */
      var sel = el('select', 'lz-up__sel');
      sel.setAttribute('aria-label', 'Choose ' + (p.opt || 'option') + ' for ' + (p.title || 'item'));
      var optName = p.opt && p.opt.indexOf('/') === -1 ? p.opt : 'option';
      var ph = el('option', null, 'Choose ' + optName);
      ph.value = '';
      sel.appendChild(ph);
      vars.forEach(function (v) {
        var o = el('option', null, v.l || 'Option');
        o.value = String(v.id);
        o.setAttribute('data-price', v.p || '');
        sel.appendChild(o);
      });
      sel.setAttribute('data-opt', p.opt || '');
      sel.addEventListener('change', function (e) {
        /* Keep this change event away from Dawn's <cart-items>/<cart-drawer-items>: their 'change'
           listener treats any input as a quantity box and shows "increments of undefined". */
        e.stopPropagation();
        sel.classList.remove('lz-up__sel--err');
        var opt = sel.options[sel.selectedIndex];
        if (opt && opt.getAttribute('data-price')) {
          price.textContent = '';
          if (p.compare) price.appendChild(el('s', null, p.compare));
          price.appendChild(document.createTextNode(opt.getAttribute('data-price')));
        }
      });
      card.appendChild(sel);
      add.setAttribute('data-lz-upsell-add', '');
    } else {
      add.setAttribute('data-lz-upsell-add', String(vars.length === 1 ? vars[0].id : p.v));
    }
    card.appendChild(add);
    return card;
  }

  function fill(box) {
    if (box.__lzFilled) return;
    box.__lzFilled = true;
    var src = box.getAttribute('data-src');
    var row = box.querySelector('[data-lz-upsell-row]');
    if (!src || src.charAt(0) !== '/' || !row) return;
    var exclude = (box.getAttribute('data-exclude') || '').split(',');
    var skipOffers = box.hasAttribute('data-skip-offers');
    var minPaise = parseInt(box.getAttribute('data-min') || '0', 10) || 0;

    load(src)
      .then(function (list) {
        if (!box.isConnected) return;
        var picks = list
          .map(function (p) {
            /* Price floor (e.g. B2G1 Rs.400+): drop variants below it; products left with none go. */
            if (!minPaise || !p || !Array.isArray(p.vars)) return p;
            var vars = p.vars.filter(function (v) { return typeof v.pc !== 'number' || v.pc >= minPaise; });
            if (!vars.length) return null;
            var q = {};
            for (var k in p) q[k] = p[k];
            q.vars = vars;
            if (vars.length === 1) { q.v = vars[0].id; q.price = vars[0].p; }
            return q;
          })
          .filter(function (p) {
            return p && p.id && exclude.indexOf(String(p.id)) === -1 && !(skipOffers && p.off);
          })
          .slice(0, MAX_CARDS);
        if (!picks.length) {
          box.hidden = true;
          return;
        }
        var frag = document.createDocumentFragment();
        picks.forEach(function (p) { frag.appendChild(buildCard(p)); });
        row.textContent = '';
        row.appendChild(frag);
        box.hidden = false;
      })
      .catch(function (e) {
        box.hidden = true;
        console.error('LZ upsell: could not load suggestions', e);
      });
  }

  var toastTimer = null;
  function toast(msg) {
    var t = document.getElementById('lz-up-toast');
    if (!t) {
      t = el('div', 'lz-up__toast');
      t.id = 'lz-up-toast';
      t.setAttribute('role', 'alert');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('is-in');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-in'); }, 2200);
  }

  function scan() {
    var boxes = document.querySelectorAll('[data-lz-upsell]');
    for (var i = 0; i < boxes.length; i++) fill(boxes[i]);
  }

  function post(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json();
    });
  }

  function refreshDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parser = new DOMParser();
        if (sections['cart-drawer']) {
          var fresh = parser.parseFromString(sections['cart-drawer'], 'text/html').getElementById('CartDrawer');
          var live = document.getElementById('CartDrawer');
          if (fresh && live) live.innerHTML = fresh.innerHTML;
        }
        if (sections['cart-icon-bubble']) {
          var nb = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          var ob = document.getElementById('cart-icon-bubble');
          if (nb && ob) ob.innerHTML = nb.innerHTML;
        }
        var drawerEl = document.querySelector('cart-drawer');
        if (drawerEl) {
          drawerEl.classList.remove('is-empty');
          drawerEl.classList.add('animate', 'active');
        }
      });
  }

  /* /cart page: re-fetch the page once and swap the cart items + footer sections and the bubble. */
  function refreshCartPage() {
    return fetch(window.location.pathname, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var live = document.querySelectorAll('.shopify-section');
        for (var i = 0; i < live.length; i++) {
          var id = live[i].id || '';
          if (!/__cart-items$|__cart-footer$/.test(id) && id !== 'shopify-section-cart-icon-bubble') continue;
          var fresh = doc.getElementById(id);
          if (fresh) live[i].innerHTML = fresh.innerHTML;
        }
        var ob = document.getElementById('cart-icon-bubble');
        var nb = doc.getElementById('cart-icon-bubble');
        if (ob && nb) ob.innerHTML = nb.innerHTML;
      });
  }

  function add(button, variantId) {
    if (busy) return;
    busy = true;
    var inDrawer = !!button.closest('#CartDrawer');
    var label = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';

    post('/cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] })
      .then(function (data) {
        if (data && data.status) throw new Error(data.description || data.message || 'Could not add');
        return inDrawer ? refreshDrawer() : refreshCartPage();
      })
      .then(function () {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
        }
      })
      .catch(function (e) {
        console.error('LZ upsell: add failed', e);
        if (button.isConnected) {
          button.textContent = 'Unavailable';
          setTimeout(function () {
            if (button.isConnected) {
              button.textContent = label;
              button.disabled = false;
            }
          }, 2000);
        }
      })
      .then(function () { busy = false; });
  }

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || typeof t.closest !== 'function') return;
    var btn = t.closest('[data-lz-upsell-add]');
    if (!btn || btn.disabled) return;
    event.preventDefault();
    var variantId = btn.getAttribute('data-lz-upsell-add');
    if (!variantId) {
      var card = btn.closest('.lz-up__card');
      var sel = card && card.querySelector('.lz-up__sel');
      if (!sel || !sel.value) {
        if (sel) sel.classList.add('lz-up__sel--err');
        var opt = sel && sel.getAttribute('data-opt');
        toast('Please choose ' + (opt ? opt.toLowerCase().replace(' / ', ' and ') : 'color or size') + ' before adding');
        return;
      }
      variantId = sel.value;
    }
    add(btn, variantId);
  });

  /* Class-based fallback for browsers without CSS :has() (older iPhones/Android): mark <html>
     while the cart drawer is open or on the /cart page. */
  function syncCartOpen() {
    var drawer = document.querySelector('cart-drawer');
    var open = !!(drawer && drawer.classList.contains('active')) || !!document.querySelector('cart-items');
    document.documentElement.classList.toggle('lz-cart-open', open);
  }

  function watchDrawer() {
    syncCartOpen();
    var drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(syncCartOpen).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    injectStyles();
    watchDrawer();
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
